import { Button, Flex, Main, Paper, Span } from "@goodfill/ui-components";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

interface Props {
  bondId?: string;
}

export const BondNotFound: React.FC<Props> = ({ bondId }) => {
  const navigate = useNavigate();

  const goToDashboard = useCallback(() => {
    navigate("/");
  }, [navigate]);

  if (!bondId) {
    return null;
  }

  return (
    <Main>
      <Flex verticalMargin={12}>
        <Paper fit={true}>
          <Flex direction="col" gap={12} verticalMargin={6} horizontalPadding={6} verticalPadding={6} justify="center">
            <Span red={true} font="semibold" size="xl">
              Bond <em>{`"${bondId}"`}</em> not found!
            </Span>
            <Flex width={52}>
              <Button fill primary={true} onClick={goToDashboard}>
                Go to Dashboard
              </Button>
            </Flex>
          </Flex>
        </Paper>
      </Flex>
    </Main>
  );
};
